import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { ComunaService } from 'src/app/services/comuna.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ProvinciaService } from 'src/app/services/provincia.service';
import { RegionService } from 'src/app/services/region.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { FuncionesService } from 'src/app/shared/validadores/funciones.service';
import { Tbcomunas } from '../chofer/shared/tbcomunas.model';
import { Tbprovincias } from '../chofer/shared/tbprovincias.model';
import { Tbregiones } from '../chofer/shared/tbregiones.model';
import { Tbcondipag } from '../../condipag/shared/tbcondipag.model';
import { AddEditProveedorComponent } from './add-edit-proveedor/add-edit-proveedor.component';

@Component({
  selector: 'app-proveedor',
  templateUrl: './proveedor.component.html',
  styleUrls: ['./proveedor.component.scss'],
  providers: [SecurityService],
})
export class ProveedorComponent implements OnInit {
  @ViewChild(AddEditProveedorComponent, { static: true }) modalAddEdit: AddEditProveedorComponent;
  // Form
  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  loading: boolean = false;
  listaRegistros: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private regionService: RegionService,
    private provinciaService: ProvinciaService,
    private comunaService: ComunaService,
    private condicionPagoService: CondicionPagoService,
    private clienteProveedorService: ClienteProveedorService
  ) {
    this.log = this.clog.log('PROVEEDORES');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.createForms();
  }

  showModalAdd() {
    this.modalAddEdit.show();
  }

  private createForms() {
    this.formHeader = this.fb.group({
      rut: [null, [Validators.required]],
      nombre: [null, [Validators.required]],
    });
  }

  buscar(pageNumber: number = 1) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber;
    const { rut, nombre, enviar_pdf, enviar_xml, orden_envio } = this.formHeader.value;
    this.listaRegistros = null;
    const inputParams = {
      entidad: {
        cliente_proveedor: {
          empresa_rut: this.rutEmpresa,
          rut: rut === null ? 0 : this.rutService.QuitarDV(rut),
          nombre: nombre === null ? '' : nombre,
        },
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.clienteProveedorService.obtenerProveedoresDTO(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      this.paginationContext.RecordsCount = totalRegistros;
      this.paginationContext.CurrentPage = paginaActual;
      this.paginationContext.PagesCount = totalPaginas;
      this.listaRegistros = registros;

      this.listaRegistros.forEach((p) => {
        p.cliente_proveedor.rutFormato = this.rutService.AgregarDV(p.cliente_proveedor.rut);
      });

      this.loading = false;
    });
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage);
  }

  view(proveedor) {
    this.modalAddEdit.showToView(proveedor);
  }

  edit(proveedor) {
    this.modalAddEdit.showToEdit(proveedor);
  }

  delete(proveedor) {}
}
